'use client';

import { Containers } from '@/components';
import { Widgets } from '@/components/widgets';
import { CompanySubnav } from '@/components/elements/CompanySubnav';

export default function OverviewPage() {
    return (
        <>
            <CompanySubnav currentLabel="Overview" />
            <Containers.Section el={<Widgets.CompanyHeroSection />} />
            <Containers.Section el={<Widgets.WhyWeStarted />} />
            <Containers.Section el={<Widgets.HeroOvalDivider />} />
            <Containers.Section el={<Widgets.OurMission />} />
            <Containers.Section el={<Widgets.LeaderShipTeam />} />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}
